import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import NtaPaletteLegendIcon from '../Instructions/NtaPaletteLegendIcon';
import { NTA_COLORS } from '../constants';
import { ntaPageCss } from '../typography';
import useNtaPaletteCounts from './useNtaPaletteCounts';

const Legend = styled.div`
  display: ${({ $compact }) => ($compact ? 'flex' : 'grid')};
  flex-direction: column;
  grid-template-columns: ${({ $compact }) => ($compact ? 'none' : '1fr 1fr')};
  gap: ${({ $compact }) => ($compact ? '8px' : '8px 10px')};
  align-items: ${({ $compact }) => ($compact ? 'stretch' : 'center')};
  ${ntaPageCss}
`;

const LegendRow = styled.div`
  display: flex;
  align-items: ${({ $compact }) => ($compact ? 'flex-start' : 'center')};
  gap: 6px;
  min-width: 0;
  grid-column: ${({ $fullWidth, $compact }) =>
    $fullWidth && !$compact ? '1 / -1' : 'auto'};
`;

const LegendText = styled.p`
  margin: 0;
  flex: 1;
  min-width: 0;
  color: ${NTA_COLORS.paletteLabel};
  font-size: ${({ $compact }) => ($compact ? '12px' : '13px')};
  line-height: ${({ $compact }) => ($compact ? '16px' : '18px')};
  white-space: ${({ $nowrap, $compact }) =>
    $nowrap && !$compact ? 'nowrap' : 'normal'};
  ${ntaPageCss}
`;

const COUNT_KEY = {
  'not-visited': 'notVisited',
  'not-answered': 'notAnswered',
  answered: 'answered',
  'marked-for-review': 'markedForReview',
  'answered-marked': 'answeredMarked'
};

const LEGEND_LABEL = {
  'not-visited': 'Not Visited',
  'not-answered': 'Not Answered',
  answered: 'Answered',
  'marked-for-review': 'Marked for Review',
  'answered-marked':
    'Answered & Marked for Review (will be considered for evaluation)'
};

const TAKING_ORDER = [
  'not-visited',
  'answered',
  'not-answered',
  'marked-for-review',
  'answered-marked'
];

const NtaPaletteLegend = ({ sectionUID, compact = false }) => {
  const counts = useNtaPaletteCounts(sectionUID);

  return (
    <Legend $compact={compact}>
      {TAKING_ORDER.map((key) => {
        const count = counts[COUNT_KEY[key]] ?? 0;
        const isFullWidth = key === 'answered-marked';

        return (
          <LegendRow key={key} $fullWidth={isFullWidth} $compact={compact}>
            <NtaPaletteLegendIcon
              icon={key}
              count={count}
              size={compact ? 24 : 28}
            />
            <LegendText
              $nowrap={!isFullWidth}
              $fullWidth={isFullWidth}
              $compact={compact}
            >
              {LEGEND_LABEL[key]}
            </LegendText>
          </LegendRow>
        );
      })}
    </Legend>
  );
};

export default NtaPaletteLegend;

NtaPaletteLegend.propTypes = {
  sectionUID: PropTypes.string,
  compact: PropTypes.bool
};
